export const IntranetEvaluationFilePerformance = {
    path: '/intranet_evaluation_file_performances',
    name: 'intranet_evaluation_file_performances',
    component: () => import('@/views/Intranet/IntranetEvaluationFilePerformancePage.vue'),
}